/**
 * Cribbed from datacenter.js. Parses simple markdown.
 * @param {string} txt - Directly from the google sheet cell
 * @param {string} el - El to wrap around the markdown
 * @return {string} - markdown->html string
 */
export default function markdown() {
  return function(txt, el = 'p') {
    if (txt === null) {
      return txt;
    }

    let _txt = txt;
    // parse the string otherwise do it recursively
    if (typeof _txt !== 'string') {
      Object.keys(_txt).forEach(i => {
        _txt[i] = markdown()(_txt[i]);
      });
      return _txt;
    }
    _txt = _txt
      .replace(/(^|\W)\*(.*?)\*($|\W)/mg, '$1<strong>$2</strong>$3')
      .replace(/(^|\W)_(.*?)_($|\W)/mg, '$1<em>$2</em>$3')
      .replace(/\[(.*?)\]\((.*?)\)/mg, '<a href="$2" target="_self">$1</a>')
      .replace(/\n\s*\n\s*/mg, '</p><p>');
    const openingTag = el ? `<${el}>` : '';
    const closingTag = el ? `</${el}>` : '';
    return `${openingTag}${_txt}${closingTag}`;
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/filters/markdownFilter.js
 **/